import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Typography,
  TextField,
  IconButton,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Avatar,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import {
  // apiCallClaimMediaList,
  apiCallSendClaimChat,
  apiCallClaimMessageEdit,
  apiCallClaimMessageDelete,
} from "../../../../Core/Apicall";
import { useLocation, useNavigate } from "react-router-dom";
import { RootState } from "../../../../Redux/Store";
import { useSelector } from "react-redux";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import SendIcons from "../../../../assets/Images/SideMenueIcons/Ic_Chat.png"
import LEFT_ERROR from "../../../../assets/Images/SideMenueIcons/LEFT_ERROR.png"

interface Report {
  _id: string;
  message: string;
  fullName: string;
  userId?: string;
  isActive?: boolean;
  profileImage?: string;
  createdAt?: string;
}
export interface Pagination {
  page: number;
  limit: number;
  hasMore: boolean;
  total?: number;
}
const VenueMediaReports: React.FC = () => {
  const [reports, setReports] = useState<Report[]>([]);
  const [message, setMessage] = useState("");
  const [editingReport, setEditingReport] = useState<Report | null>(null);
  const [openDelete, setOpenDelete] = useState<Report | null>(null);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedReport, setSelectedReport] = useState<Report | null>(null);
  const [openAvatar, setOpenAvatar] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [autoScroll, setAutoScroll] = useState(true);


  const [pagination, setPagination] = useState<Pagination>({
    page: 1,
    limit: 30,
    hasMore: true,
  });
  const userdata: any = useSelector((state: RootState) => state.global.token);
  const userId = userdata?.data?.userId;
  const location = useLocation();
  const MediaId = location.state?._id || "";
  const mediaData = location.state || {}
  const navigator = useNavigate()
  const chatEndRef = useRef<HTMLDivElement | null>(null);

  const scrollToBottom = () => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  const listRef = useRef<HTMLDivElement | null>(null);

  const handleScroll = () => {
    if (!listRef.current || loadingMore || !pagination.hasMore) return;
    if (listRef.current.scrollTop === 0) {
      const nextPage = pagination.page + 1;
      fetchReports(nextPage);
      setAutoScroll(false)
    }
  };

  const fetchReports = async (newPage = 1) => {
    try {
      if (loadingMore || !pagination.hasMore)
        return; setLoadingMore(true);
      // const res = await apiCallClaimMediaList({

      //   reportId: MediaId,
      //   senderId: userId,
      //   receiverId: mediaData?.userId,
      //   offset: newPage,
      //   limit: pagination.limit,
      // });
      // if (res.success) {
      //   if (newPage === 1) {
      //     setReports(res.data || []);
      //   } else { setReports((prev) => [...prev, ...(res.data || [])]); }
      //   setPagination((prev) => ({ ...prev, page: newPage, hasMore: res.data && res.data.length > 0, }));
      // }
    } catch (error) { } finally { setLoadingMore(false); }
  };


  useEffect(() => {
    fetchReports(1);
    const intervalId = setInterval(() => {
      fetchReports(1);
    }, 15000);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (autoScroll) {
      scrollToBottom();
    }
  }, [reports]);

  const handleSend = async () => {
    if (!message.trim()) return;
    try {
      if (editingReport) {
        await apiCallClaimMessageEdit({
          reportId: editingReport._id,
          senderId: userId,
          receiverId: editingReport?._id,
          message,
        });
        setEditingReport(null);
      } else {
        // await apiCallClaimMediaAdd({
        //   reportId: MediaId,
        //   senderId: userId,
        //   receiverId: mediaData?.userId,
        //   message,
        // });
      }
      setAutoScroll(true);
      setMessage("");
      fetchReports();
    } catch (error) {

    }
  };

  const handleDelete = async (id: string) => {
    try {
      await apiCallClaimMessageDelete({
        reportId: id,
        userId: userId,
        isDelete: true,
      });
      setOpenDelete(null);
      fetchReports();
    } catch (error) {

    }
  };
  const handleMenuClick = (event: React.MouseEvent<HTMLElement>, report: Report) => {
    setAnchorEl(event.currentTarget);
    setSelectedReport(report);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedReport(null);
  };

  const handleEdit = () => {
    if (selectedReport) {
      setEditingReport(selectedReport);
      setMessage(selectedReport.message);
      handleMenuClose();
    }
  };

  const handleDeleteClick = () => {
    if (selectedReport) {
      setOpenDelete(selectedReport);
      handleMenuClose();
    }
  };

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString([], {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };


  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "85vh",
        border: "1px solid #F0F5F71A",
        borderRadius: 3,
        overflow: "hidden",
        background: "white"
      }}
    >
      <Dialog open={openAvatar} onClose={() => setOpenAvatar(false)}
        PaperProps={{
          sx: {
            backgroundColor: "transparent",
            boxShadow: "none",
          },
        }}>

        <img
          src={mediaData?.profileImagePath || ""}
          alt={mediaData?.message}
          style={{
            width: 200,
            height: 200,
            borderRadius: "50%",
            objectFit: "cover",
          }}
        />
      </Dialog>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          p: 2,
          borderBottom: "1px solid #F0F5F71A",
          backgroundColor: "black",
        }}
      >
        <img onClick={() => navigator(-1)} src={LEFT_ERROR} style={{ height: "40px", marginRight: "10px", cursor: "pointer" }} alt="" />
        <Avatar
          src={mediaData?.profileImagePath || ""}
          sx={{ width: 40, height: 40, mr: 2, bgcolor: "#999", cursor: "pointer" }}
          onClick={() => setOpenAvatar(true)}

        >
          {mediaData?.message?.[0]}
        </Avatar>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, color: "white", fontSize: "20px", textTransform: "capitalize" }}>
          {mediaData?.message || ""}
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "end",
          width: "100%",
          height: "100%",
          overflowY: "auto",
          px: 1,
          py: 2,
          background: "black",
          "&::-webkit-scrollbar": {
            width: "8px",
          },
          "&::-webkit-scrollbar-track": {
            background: "transparent",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "gray",
            borderRadius: "6px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: "white",
          },
          scrollbarWidth: "thin",
          scrollbarColor: "gray transparent",
        }}
        ref={listRef}
        onScroll={handleScroll}
      >
        {[...reports].reverse().map((msg: any, index) => {
          const isMine = msg.senderId === userId;
          const msgDate = formatDate(msg.createdAt || '');
          const prevDate =
            index > 0 ? formatDate(reports[reports.length - index].createdAt || '') : null;

          const showDate = msgDate !== prevDate;
          return (
            <>
              {showDate && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    mb: 3,
                    width: "100%"
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{
                      background: "#1f1f1f",
                      color: "gray",
                      fontSize: "12px",
                      px: 1.5,
                      py: 0.5,
                      borderRadius: "12px",
                    }}
                  >
                    {msgDate}
                  </Typography>
                </Box>
              )}
              <Box
                key={msg._id}
                sx={{
                  display: "flex",
                  justifyContent: isMine ? "flex-end" : "flex-start",
                  mb: 2,
                  px: 1,
                  width: "100%",
                  position: "relative",
                  "&:hover .menu-btn": {
                    opacity: 1,
                    visibility: "visible",
                  },
                }}
              >

                {!isMine && (
                  <Avatar
                    src={msg.senderProfileImage || ""}
                    sx={{ width: 32, height: 32, mr: 1 }}
                  >
                    {msg.senderName?.[0]}
                  </Avatar>
                )}

                <Paper
                  sx={{
                    p: "10px",
                    maxWidth: "60%",
                    borderRadius: 3,
                    background: isMine
                      ? "linear-gradient(140.74deg, rgba(26, 196, 168, 0.2) 22.49%, rgba(66, 171, 237, 0.2) 77.51%)"
                      : "#F0F5F733",
                    borderTopRightRadius: isMine ? 0 : 12,
                    borderTopLeftRadius: isMine ? 12 : 0,
                    boxShadow: 1,
                    position: "relative",
                    paddingRight: "20px",
                  }}
                >
                  {!isMine && (
                    <Typography
                      variant="caption"
                      sx={{
                        fontWeight: "700",
                        mb: 0,
                        display: "block",
                        background:
                          "linear-gradient(93.72deg, #1AC4A8 0%, #42ABED 99.58%)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        textTransform: "capitalize",
                        fontSize: "14px",
                      }}
                    >
                      {msg.senderName}
                    </Typography>
                  )}

                  <Typography
                    variant="body2"
                    sx={{
                      wordWrap: "break-word",
                      color: "white",
                      fontSize: "14px",
                    }}
                  >
                    {msg.message}
                    <span style={{
                      color: "gray",
                      textTransform: "uppercase",
                      fontSize: "10px",
                      width: "100%",
                      textAlign: "right",
                      marginLeft: "0px",
                      display: "block",
                      marginTop: "4px"
                    }} >
                      {new Date(msg.createdAt).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                      })}
                    </span>
                  </Typography>



                  {isMine && (
                    <IconButton
                      size="small"
                      className="menu-btn"
                      sx={{
                        position: "absolute",
                        top: 6,
                        right: 0,
                        opacity: 0,
                        visibility: "hidden",
                        transition: "opacity 0.2s ease",
                      }}
                      onClick={(e) => handleMenuClick(e, msg)}
                    >
                      <MoreVertIcon style={{ color: "white" }} fontSize="small" />
                    </IconButton>
                  )}
                </Paper>
              </Box>
            </>
          );
        })}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          PaperProps={{
            sx: {
              backgroundColor: "black", // change this to any color you like
            },
          }}
        >
          <MenuItem sx={{ color: "white" }} onClick={handleEdit}>Edit</MenuItem>
          <MenuItem onClick={handleDeleteClick} sx={{ color: "red" }}>
            Delete
          </MenuItem>
        </Menu>


        <div ref={chatEndRef} />
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          p: "10px 20px",
          backgroundColor: "black",
          borderTop: "1px solid #F0F5F71A",

        }}
      >
        <div style={{
          display: "flex",
          alignItems: "center",
          padding: "10px 15px",
          backgroundColor: "#F0F5F71A",
          width: "100%",
          borderRadius: "60px",
          paddingLeft: "20px"
        }}>
          <TextField
            placeholder={editingReport ? "Edit message..." : "Write here..."}
            fullWidth
            multiline
            rows={3}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSend()}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "0px",
                fontSize: "16px",
                padding: "0px",
                color: "white",
                "& fieldset": {
                  border: "none",
                },
                "& textarea": {
                  color: "white",
                  padding: "4px",
                  resize: "none",
                  height: "23px !important",
                  fontWeight: "100",
                  overflow: "auto",
                  "&::placeholder": {
                    color: "gray",
                    opacity: 1,
                    fontSize: "16px",
                  },
                  "&::-webkit-scrollbar": {
                    width: "6px",
                  },
                  "&::-webkit-scrollbar-track": {
                    background: "transparent",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "gray",
                    borderRadius: "4px",
                  },
                  "&::-webkit-scrollbar-thumb:hover": {
                    backgroundColor: "white",
                  },
                  scrollbarWidth: "thin",
                  scrollbarColor: "gray transparent",
                },
              },
            }}
          />
          <img onClick={handleSend} src={SendIcons} style={{ height: "30px", cursor: "pointer" }} alt="" />
        </div>
      </Box>


      <Dialog open={!!openDelete} onClose={() => setOpenDelete(null)}>
        <DialogTitle>Delete Message</DialogTitle>
        <DialogContent>Are you sure you want to delete?</DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDelete(null)}>Cancel</Button>
          <Button
            color="error"
            variant="contained"
            onClick={() => handleDelete(openDelete?._id || "")}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default VenueMediaReports;
